import { useEffect, useMemo, useState } from 'react';

import UMSG from 'config/umsg.singleton';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const fromMessagesToStrings = (messages) =>
  asArray(messages).map((item) => {
    const message = fromAnyToTrimmed(item?.message);
    return item?.count ? `(${item?.count}) ${message}` : message;
  });

const fromMessagesToMetaAndData = (messages) =>
  asArray(messages).map((item) => {
    const message = fromAnyToTrimmed(item?.message);
    return { data: item?.count ? `(${item?.count}) ${message}` : message, meta: item };
  });

const useGlobalMessages = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => UMSG.subscribe(() => void setMessages(UMSG.all())), []);

  return useMemo(
    () => ({
      items: messages,
      strings: fromMessagesToStrings(messages),
      metaAndData: fromMessagesToMetaAndData(messages),
      clear: UMSG.clear,
    }),
    [messages],
  );
};

export default useGlobalMessages;
